<template lang="pug">
    div
        h1 {{title}} 
        v-flex.xs12
            slot(name="prependContent")
        crud-form(
            :editable="editable"
            :readOnly="readOnly"
            :fields="formFields"
            :submitText="confirmText"
            @reset="resetValues()"
            @calculate="assignValues($event)"
            @submitForm="$emit('form:submit')"
            @editable="$emit('editForm',$event)"
            ref="stepForm"
            )
                template(slot="prependButton")
                    v-btn.subheading.mt-3(
                        block
                        @click="$emit('step:prev')"
                        color="info"
                        v-if="prevButton"
                        ) 
                        v-icon(left) arrow_left
                        span {{prevButton}}
                template(slot="appendButton")
                    v-btn.subheading.mt-3(
                        block
                        @click="$emit('step:exit')"
                        color="grey darken-3"
                        dark
                        v-if="exitButton"
                        )
                        span {{exitButton}}
                        v-icon(right) close
                    v-btn.subheading.mt-3(
                        block
                        @click="$emit('step:finish')"
                        color="success"
                        v-if="finishButton"
                        )
                        span {{finishButton}}
                        v-icon(right) check
                    v-btn.subheading.mt-3(
                        block
                        @click="$emit('step:next')"
                        color="info"
                        v-if="nextButton"
                        )
                        span {{nextButton}}
                        v-icon(right) arrow_right
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
export default {
    name: 'commercial-info-step',
    props: {
        /**
         * @description
         * Fields for the crud form
         */
        fields: {
            type: Array,
            default: () => []
        },
        /**
         * @description
         * Item to assign the form changes as props
         */
        value: {
            type: Object,
            default: () => {}
        },
        /**
         * @description
         * Title for the step
         */
        title: {
            type: String,
            default: () => ''
        },
        /**
         * @description
         * Enables the previous button and sets its Text
         */
        prevButton: {
            type: String,
            default: () => ''
        },
        /**
         * @description
         * Enables the send button and sets its Text
         */
        nextButton: {
            type: String,
            default: () => ''
        },
        /**
         * @description
         * Enables the finish button
         */
        finishButton: {
            type: String,
            default: () => ''
        },
        /**
         * @description
         * Enables the exit button
         */
        exitButton: {
            type: String,
            default: () => ''
        },
        /**
         * @description
         * text for the crudForm button
         */
        confirmText: {
            type: String,
            default: () => 'CREAR'
        },
        /**
         * @description
         * Enables the edit switch for the crudform
         */
        editable: {
            type: Boolean,
            default: () => false
        },
        /**
         * @description
         * Enables the readOnly for the crudform
         */
        readOnly: {
            type: Boolean,
            default: () => false
        },
    },
    data: function() {
        return {
            /**
             * store initial values
             */
            defaultFields: {},
            /**
             * @description
             * store initial Item properties
             */
            defualtItemProps: {}
        }
    },
    computed: {
        /**
         * @description
         * Computed property to handle fields prop mutations
         */
        formFields: {
            get: function(){
                return this.fields
            },
            set: function(e){
                this.$emit('fields:change', e)
            },
        },
        /**
         * @description
         * Computed property to handle value prop mutations
         */
        item: {
            get: function(){
                return this.value
            },
            set: function(e){
                this.$emit('input', e)
            },
        },
    },
    methods: {
        /**
         * @description
         * reset field values to initial value
         * reset item related props values to initial values
         */
        resetValues: function(){
            this.formFields = [ ...this.defaultFields ]
            this.item = Object.assign(this.item, this.defualtItemProps)
            this.$emit('form:reset')
            return
        },
        assignValues:  async function(e){
            this.$emit('loading', true)
            if(e.field === 'wh_family_id') await this.fetchSubFamilies(e.value)
            this.item[e.field] = e.value
            this.item = {...this.item}
            this.$emit('loading', false)
        },
        fetchSubFamilies: async function(familyID){
            this.formFields[4].options.data = 
                await SubfamilyService.fetchAllSubfamilyByFamilyId(familyID)
            this.formFields[4].value = ""
            this.item.wh_subfamily_id = ""
        }
    },
    watch: {
        fields: {
            handler: function(newVal) {
                let v = [...newVal]
                console.log('fields changed step', v)
            },
            deep: true,
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function(){
        this.formFields = this.fields.map(field => {
            field.value = ''
            return field
        })
    },
    beforeMount: function(){
        this.defaultFields = this.fields
        this.defualtItemProps = this.fields.reduce((obj, field) => {
            obj[field.field] = field.value || ''
            return obj
        }, {})
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>